import { Navigate, Route, Routes } from 'react-router-dom';
import AdminLayout from './components/AdminLayout';
import DashboardPage from './pages/DashboardPage';
import LoginPage from './pages/LoginPage';
import PostsModerationPage from './pages/PostsModerationPage';
import ReportsQueuePage from './pages/ReportsQueuePage';
import FeedbackQueuePage from './pages/FeedbackQueuePage';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<AdminLayout />}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/reports" element={<ReportsQueuePage />} />
        <Route path="/feedback" element={<FeedbackQueuePage />} />
        <Route path="/posts" element={<PostsModerationPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
